/*
 Transactions List with pagination- present in the block details page
*/

import { TransactionDetailsComponent as TransactionDetails } from "./TransactionDetails.component";

export default TransactionDetails;
